import { Sparkles } from 'lucide-react';
import React, { ReactElement } from 'react';

import { CardTitle } from 'src/components/ui/card';
import { Skeleton } from 'src/components/ui/skeleton';

type NoveltiesSkeletonProps = {
  withHeader?: boolean;
};

export function NoveltiesSkeleton({
  withHeader = true,
}: NoveltiesSkeletonProps): ReactElement {
  const content = (
    <div className='space-y-4'>
      {[1, 2, 3, 4, 5].map((i) => (
        <Skeleton key={i} className='h-20 w-full' />
      ))}
    </div>
  );

  if (!withHeader) {
    return content;
  }

  return (
    <div className='flex h-[calc(100vh-65px)] w-full flex-col gap-6 p-6'>
      <div className='flex h-full flex-col'>
        <div className='pb-4'>
          <div className='flex flex-col gap-4 md:flex-row md:items-center md:justify-between'>
            <div className='flex items-center gap-3'>
              <Sparkles className='size-6 text-primary-default' />
              <CardTitle className='text-xl'>
                <Skeleton className='h-6 w-48' />
              </CardTitle>
              <Skeleton className='h-6 w-20 rounded-full' />
            </div>
            <div className='relative w-full md:w-80'>
              <Skeleton className='h-10 w-full' />
            </div>
          </div>
        </div>
        {content}
      </div>
    </div>
  );
}
